module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-48-47-440.5675c264.mp4";